import React, { useEffect, useState } from 'react';
import { Paper, Table, TableBody, TableCell, TableHead, TableRow, Divider, TablePagination, Button, Switch, Grid, Typography, MenuItem, Select, TextField, TableContainer } from '@mui/material';
import { Box } from '@mui/system';
import InputStylefield from '../../assets/InputStylefield';
import { IconButton } from '@mui/material';
import { Visibility, Edit, Delete } from '@mui/icons-material';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import SearchIcon from '@mui/icons-material/Search';
import { useNavigate } from 'react-router-dom';
import { getAppliedJobs } from '../../actions/userAuth';
import { useDispatch, useSelector } from 'react-redux';

export default function AppliedJobsTable({id}) {
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [checked, setChecked] = useState(false);
    const [date, setDate] = useState("");
    const [selectedOption, setSelectedOption] = useState('');
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [jobs, setJobs] = useState([]);
    const dispatch = useDispatch();
    const { user } = useSelector((state) => ({ ...state }));

    useEffect(() => {
        dispatch(getAppliedJobs({id:user.id}, (data) => {
            setJobs(data.data);
            console.log(data.data)
        }))
    }, [user]);

    const handleFromDateChange = (event) => {
        setFromDate(event.target.value);
    };



    const handleToDateChange = (event) => {
        setToDate(event.target.value);
    };

    const handleChange1 = (event) => {
        setSelectedOption(event.target.value);
    };

    const handleChange = () => {
        setChecked(!checked);
    };

    const navigate = useNavigate();


    const data = [
        { id: 1, header1: 'Ackrolix Innovation', header2: 'Data 2', header3: 'Data 3', header4: '24- April 2023', header5: 'Data 5', header6: 'Deactivate', header7: 'Data 7' },
        { id: 2, header1: 'Data 1', header2: 'UI UX Designer', header3: 'Data 3', header4: 'Data 4', header5: 'Data 5', header6: 'Activate', header7: 'Data 7' },
        { id: 3, header1: 'Data 1', header2: 'Data 2', header3: 'Data 3', header4: 'Data 4', header5: 'Data 5', header6: 'Rejected', header7: 'Data 7' },
        { id: 4, header1: 'Data 1', header2: 'Data 2', header3: 'Data 3', header4: 'Data 4', header5: 'Data 5', header6: 'Under Review', header7: 'Data 7' },
        { id: 5, header1: 'Data 1', header2: 'Data 2', header3: 'Data 3', header4: 'Data 4', header5: 'Data 5', header6: 'Draft', header7: 'Data 7' },
        { id: 6, header1: 'Data 1', header2: 'Data 2', header3: 'Data 3', header4: 'Data 4', header5: 'Data 5', header6: 'Data 6', header7: 'Data 7' },
        { id: 7, header1: 'Data 1', header2: 'Data 2', header3: 'Data 3', header4: 'Data 4', header5: 'Data 5', header6: 'Data 6', header7: 'Data 7' },
        // Add more data objects as needed
    ];

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleSearch = (event) => {
        const searchTerm = event.target.value;
    };



    const emptyRows = rowsPerPage - Math.min(rowsPerPage, data.length - page * rowsPerPage);

    return (
        <Paper sx={{ px: 5, py: 2, boxShadow: 'none', border: '1px solid #e0e0e0' }} >
            <Grid container my={2} >
                <Grid item md={4} sx={{ display: 'flex', verticalAlign: 'middle', alignItems: 'center', height: '2.5rem' }}>
                    <Typography className='text2Bold'>Show</Typography>
                    <select
                        style={{ marginLeft: '1rem', backgroundColor: '#D9E3F6' }}
                        className='profile-skills-box text2Light'

                        value={selectedOption}
                        onChange={handleChange}
                    >
                        <option value="">None</option>
                        <option value="option1">Option 1</option>
                        <option value="option2">Option 2</option>
                        <option value="option3">Option 3</option>
                    </select>
                    <Typography className='text2Bold' ml={1}>Enteries</Typography>
                </Grid>
                <Grid item md={6}></Grid>

                <Grid item md={2} sx={{ display: 'flex', verticalAlign: 'middle', alignItems: 'center', height: '2.5rem' }}>
                    <TextField
                        sx={{ marginLeft: '1rem', backgroundColor: '#D9E3F6' }}
                        className='profile-skills-box text2Light'
                        variant="outlined"
                        size="small"
                        placeholder="Search"
                        onChange={handleSearch}
                        InputProps={{
                            endAdornment: <SearchIcon sx={{ opacity: '0.5' }} />,
                        }}
                    />
                </Grid>
            </Grid >

            <Paper sx={{ boxShadow: 'none', border: '1px solid #e0e0e0' }}>
                <Grid container>
                    <Grid item xs={12}>
                        <TableContainer sx={{ width: '100%', overflowX: 'auto' }}>
                            <Table width="auto">
                                <TableHead>
                                    <TableRow>
                                        <TableCell className='text2Bold' style={{ width: 'fit-content', textAlign: 'left' }}>
                                            Company
                                        </TableCell>
                                        <TableCell className='text2Bold' style={{ width: 'fit-content', textAlign: 'left' }}>
                                            Category
                                        </TableCell>
                                        <TableCell className='text2Bold' style={{ width: 'fit-content', textAlign: 'center' }}>
                                            Job Types
                                        </TableCell>
                                        <TableCell className='text2Bold' style={{ width: 'fit-content', textAlign: 'left' }}>
                                            Applied on
                                        </TableCell>


                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {(rowsPerPage > 0
                                        ? jobs?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                        : jobs
                                    ).map((row) => (
                                        <TableRow key={row.id}>
                                            <TableCell className='text2Mid' style={{ width: 'fit-content', textAlign: 'left', color: '#2544EE' }}>
                                                <p className='text2Bold' style={{ margin: '0px', cursor: 'pointer' }} onClick={() => navigate('/candidate/job-view')}>{row.header1}</p>
                                                <LocationOnOutlinedIcon sx={{ fontSize: '16px' }} />
                                                <span className='text2Mid' style={{ color: '#061C3D' }} >Sector 44, Gurugram, Haryana</span>
                                            </TableCell>
                                            <TableCell className='text2Bold' style={{ width: 'fit-content', textAlign: 'left', }}>{row.header2}</TableCell>
                                            <TableCell style={{ width: 'fit-content', textAlign: 'center' }}>
                                                <Box
                                                    className="text2Mid"
                                                    sx={{
                                                        backgroundColor: row.header3 === 'Data 3' ? '#5099B0' : '#8A82E3',
                                                        borderRadius: '5px',
                                                        px: 2,
                                                        py: 1,
                                                        color: '#fff',
                                                    }}
                                                >
                                                    {row.header3}
                                                </Box>
                                            </TableCell>
                                            <TableCell className='text2Bold' style={{ width: 'fit-content', textAlign: 'left', color: '#2544EE', fontWeight: 'bold' }}>{row.header4}</TableCell>

                                        </TableRow>
                                    ))}

                                    {emptyRows > 0 && (
                                        <TableRow style={{ height: 53 * emptyRows }}>
                                            <TableCell colSpan={8} />
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Grid>
                </Grid>
                <TablePagination
                    rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                    component="div"
                    count={data.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </Paper>
        </Paper>

    );
}
